export default __webpack_public_path__ + "static/media/ceramol-acn3-products-640.ae7eb783.jpg";